import api from './apiLibrary';

const API = {
    getSectors(params) {
        return api.get('/api/admin/sector', params);
    },
    createSector(data) {
        return api.post('/api/admin/sector', data);
    },
    editSector(id, data) {
        return api.put(`/api/admin/sector/${id}`, data);
    },
    getSector(id) {
        return api.get(`/api/admin/sector/${id}`);
    },
    deleteSector(id) {
        return api.delete(`/api/admin/sector/${id}`);
    },
};

export default API;
